<template>
    <div class="doctor">
        <div class="app-sidebar" :class="{ hide : !visible, open: visible }">
            <app-sidebar v-on:toggleSidebar="toggle"></app-sidebar>
        </div>
        <div class="movil-close-zone" :class="{ open: visible }" v-on:click="toggle">

        </div>
        <div class="app-main" :class="{ navOpen: visible }">
            <app-navbar v-on:toggleSidebar="toggle"></app-navbar>
            <div class="content-container">
                <router-view v-on:toggleSidebar="toggle" :sidevisible="visible"></router-view>
            </div>
        </div>
    </div>
</template>
<script>
    import Sidebar from './Sidebar.vue';
    import Navbar from './Navbar.vue';
    import {mapActions} from 'vuex';
    export default {
        created() {
            // Load data
            if(!this.user.full_name){
                this.loadData();
            }
            // Load language
            if(!this.$store.getters.language.app){
                this.loadLanguage();
            }
        },
        data() {
            return {
                visible: window.innerWidth >= 1190
            }
        },
        computed:{
            // Get user
            user() {
                return this.$store.getters.user;
            },
            // Get show navbar
            show() {
                return this.$store.getters.navbar.show;
            },
            // Get Translate
            translate(){
                return this.$store.getters.language.app[this.lang].prestador;
            },
            // Get lang
            lang(){
                return this.$store.getters.language.lang;
            }
        },
        methods: {
            // LoadData and LoadLanguage
            ...mapActions({
                fetchData: 'loadData',
                fetchLanguage: 'loadLanguage'
            }),
            // LoadData from actions
            loadData() {
                this.fetchData();
            },
            // LoadLanguage from actions
            loadLanguage() {
                this.fetchLanguage();
            },
            // Show Toggle
            toggle() {
                this.visible = !this.visible;
            }
        },
        components: {
            appSidebar: Sidebar,
            appNavbar: Navbar
        },
        mounted() {
           /* var self = this;
            document.addEventListener('click', function(event) {
                var app_notifications = document.getElementById('app_notifications');
                if(typeof app_notifications != "undefined" && app_notifications.contains){
                    var isClickNotification = app_notifications.contains(event.target);
                    if (! isClickNotification ) {
                        if(self.show.notification){
                            self.$store.dispatch('hideNotification');
                        }
                    }
                }
                var app_profile = document.getElementById('app_profile');
                if(typeof app_profile != "undefined"){
                    var isClickProfile = app_profile.contains(event.target);
                    if (! isClickProfile ) {
                        if(self.show.profile){
                            self.$store.dispatch('hideProfile');
                        }
                    }
                }
            });*/
        }
    }
</script>
<style lang="stylus" scoped>
    @import '../../../assets/styles/variables/color.styl'
    .time-picker .dropdown
        z-index 15 !important
    @media (max-width: 600px)
        .app-navbar
            position fixed
            width 100%
            z-index 98
        .content-container
            margin-top 80px!important
    .movil-close-zone
        display none
        transition all 0.4s
        overflow hidden!important
    @media (max-width: 1190px)
        .movil-close-zone
            width 100vw
            height 100vh
            background rgba(0,0,0,0.5)
            position absolute
            z-index 99
            display none
            &.open
                display block
    .app-sidebar
        background-color color_sidebar
        color white
        height 100vh
        opacity 1
        transition all 0.5s
        visibility visible
        width 240px
        z-index 100
        &.hide
            opacity 0
            visibility hidden
            margin-left: -240px
        &.open
            left 0!important
            opacity 1
            visibility visible
            width 240px
    .doctor
        display flex
    .app-main
        flex 1
        &.navOpen
            height 100vh
            overflow-y auto!important
    .full-width
        width 100%
</style>



// WEBPACK FOOTER //
// Layout.vue?bfac1996